const InvestmentPhilosophySection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            
            {/* Left Image */}
            <div className="col-lg-6">
              <div
                className="about__thumb"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img
                      className="dark"
                      src="assets/images/new/investmt.jpg"
                      alt="Retail Investor"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
              <div
                className="about__content"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">
                    Our Investment <span className="style2">Philosophy</span>
                  </h2>
                  <p>
                    We believe in India's demographic advantage and focus on
                    identifying companies with strong financial potential and
                    long-term sustainability. Our expertise lies in locating
                    sectors emerging from deep recessions and identifying
                    well-positioned companies with honest management to benefit
                    from economic turnarounds.
                  </p>
                </div>
              </div>
            </div>

             {/* Why Choose Us */}
            <div className="col-lg-12 mt-30">
              <div className="highlight" data-aos="fade-up" data-aos-duration="600">
                <h3 className="text-center mb-5">Why Choose Our Approach?</h3>
                <div className="row">
                  <div className="col-md-4 text-center mb-4">
                    <i
                      className="fas fa-chart-line fa-3x mb-3"
                      style={{ color: "var(--accent-color)" }}
                    ></i>
                    <h5>Systematic Strategy</h5>
                    <p>
                      Structured approach to identify opportunities across market
                      conditions
                    </p>
                  </div>
                  <div className="col-md-4 text-center mb-4">
                    <i
                      className="fas fa-shield-alt fa-3x mb-3"
                      style={{ color: "var(--accent-color)" }}
                    ></i>
                    <h5>Risk Management</h5>
                    <p>
                      Multiple strategies to balance risk and return potential
                    </p>
                  </div>
                  <div className="col-md-4 text-center mb-4">
                    <i
                      className="fas fa-search-dollar fa-3x mb-3"
                      style={{ color: "var(--accent-color)" }}
                    ></i>
                    <h5>Sector Expertise</h5>
                    <p>
                      Specialized knowledge in identifying turnaround
                      opportunities
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Core Principles */}
            <div className="col-lg-12 mt-30">
              <div className="about__content">
                <div
                  className="about__content-inner"
                  data-aos="fade-up"
                  data-aos-duration="500"
                >
                  <h3 className="section-title mb-3">Core Principles</h3>
                  <div className="key-points">
                    <ul>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        <b>Demographic Advantage:</b> Belief in India's youthful
                        population and growing workforce as a sustainable growth
                        driver
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        <b>Sector Identification:</b> Specializing in locating
                        sectors emerging from deep recessions
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        <b>Management Quality:</b> Focusing on companies with
                        honest, capable management teams
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        <b>Strategic Timing:</b> Purchasing during market
                        downturns and selling during overheated markets
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        <b>Hybrid Approach:</b> Combining various strategies to
                        maximize returns while managing risk
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Investment Strategy */}
            <div className="col-lg-12 mt-30">
              <div className="about__content">
                <div
                  className="about__content-inner"
                  data-aos="fade-right"
                  data-aos-duration="500"
                >
                  <h3 className="section-title mb-3">Our Investment Strategy</h3>
                  <p className="mb-4">
                    We at Asiatic Stock & Securities Ltd follow a hybrid yet
                    simple investment strategy involving a systematic approach
                    to investments. We believe India with its demographic
                    advantage offers sustainable GDP growth, with economic
                    parameters constantly improving compared to other countries
                    for the next 10-15 years.
                  </p>

                  <h4 className="mb-3">Key Challenges We Address:</h4>
                  <ol className="challenge-list">
                    <li>
                      Finding sectors/sub-sectors within the economy that will
                      perform better financially or are emerging from deep
                      recessions due to improving macroeconomic conditions.
                    </li>
                    <li>
                      Locating companies that are well-positioned for turnaround
                      or growth phases and have honest, non-manipulative
                      management.
                    </li>
                    <li>
                      Timing investments correctly - buying during market
                      downturns, using options to lower costs, and patiently
                      waiting for sector recovery.
                    </li>
                    <li>
                      Selling investments when markets are overheated,
                      expectations are high, and consensus is overwhelmingly
                      positive.
                    </li>
                  </ol>
                </div>
              </div>
            </div>

            {/* Strategies */}
            {/* <div className="col-lg-12 mt-30">
              <div className="about__content">
                <div
                  className="about__content-inner"
                  data-aos="fade-up"
                  data-aos-duration="500"
                >
                  <h3 className="section-title mb-3">
                    Broad Synopsis of Our Strategies
                  </h3>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="strategy-box">
                        <h4 className="strategy-title">1. Cash Future Trades</h4>
                        <p>
                          We utilize parts of funds to generate risk-free returns
                          from cash future spreads volatility. We specialize in
                          dividend arbitrage strategies.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="strategy-box">
                        <h4 className="strategy-title">2. Volatility Arbitrage</h4>
                        <p>
                          Option combinations that are market neutral but play on
                          volatility mispricing and interest accruing. This
                          in-house developed strategy generates returns when Nifty
                          doesn't move and larger returns during volatility spikes.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="strategy-box">
                        <h4 className="strategy-title">3. Pair Trades</h4>
                        <p>
                          When stocks in the same industry with similar products
                          and correlated returns move out of sync, we buy cheaper
                          and sell expensive stock derivatives. This strategy uses
                          only a small portion of funds due to potential MTM risks.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="strategy-box">
                        <h4 className="strategy-title">
                          4. Quantitative Strategies
                        </h4>
                        <p>
                          Proprietary trading systems built on Amibroker with 5
                          intraday quantitative strategies in the NSE FNO market
                          on a basket of 30 stocks. These employ momentum,
                          range-bound, and trend-following approaches.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

           

          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentPhilosophySection;
